export default "__VITE_ASSET__TAgI9igs__"